import { useParams, Link } from 'react-router-dom';
import { categories, allArticles } from '@/mocks/sports';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { SchemaWebPage, SchemaBreadcrumbList } from '@/components/feature/SchemaOrg';
import { siteInfo } from '@/mocks/sports';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const articles = allArticles.filter((a) => a.category === slug);

  if (!category) {
    return (
      <div className="pt-20 pb-20 text-center">
        <h1 className="font-heading text-2xl font-bold text-foreground-900">分类未找到</h1>
        <Link to="/" className="text-primary-500 hover:underline mt-4 inline-block">返回首页</Link>
      </div>
    );
  }

  return (
    <>
      <SchemaWebPage
        url={`/category/${slug}`}
        name={`${category.name} - ${siteInfo.name}`}
        description={category.description}
      />
      <SchemaBreadcrumbList
        items={[
          { name: '首页', url: '/' },
          { name: category.name, url: `/category/${slug}` },
        ]}
      />

      <div className="pt-24 pb-10 md:pb-14 bg-background-100">
        <div className="w-full px-4 md:px-6 mb-6">
          <Breadcrumb items={[{ name: category.name }]} />
        </div>
        <div className="w-full px-4 md:px-6">
          <div className="max-w-4xl mx-auto text-center">
            <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-accent-100">
              <i className={`${category.icon} text-2xl text-accent-600`}></i>
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mb-3">
              {category.name}
            </h1>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
              {category.description}
            </p>
          </div>
        </div>
      </div>

      <section className="w-full py-8 md:py-12 bg-background-50">
        <div className="w-full px-4 md:px-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto">
            {articles.map((article) => (
              <article key={article.slug} className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer">
                <Link to={`/article/${article.slug}`} className="block h-full">
                  <div className="relative h-48 md:h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center gap-4 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {article.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {article.readTime}
                      </span>
                    </div>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}